import React, {Component} from 'react';
import {Button, Icon, Input, message, Modal, notification, Popover, Radio,Checkbox } from "antd";
import { connect } from 'react-redux';
import "./storageList.css";
import {
    addLabel, addRelatedDeptIds,
    createStorageDirectory,
    deleteByDirectoryIdsAndFileIds,
    filesToDirectory,
    fileToDirectory,
    fileToDirectoryAndAddLabel,
    getAllParent,
    getByMd5s,
    getByPath, getPictureInfosByPath,
    getStorageDirectory,
    getStorageDirectoryList,
    moveByDirectoryIdsAndFileIds,
    moveToRecycle,
    recover,
    search,
    setDirectoryLabels,
    storageDirectoryRename,
    storageFileRename
} from "../actions/storageList";
import {formateData, getBatchDownloadPath} from "../actions";
import {
    HEADER_HEIGHT,
    NAVIGATE_CLOSE,
    NAVIGATE_LEVEN2_MARGIN,
    NAVIGATE_LEVEN2_WIDTH,
    NAVIGATE_OPEN
} from "../constants";
import {applicationName, isIE} from "../utils";
import cookie from 'react-cookies';
import $ from "jquery";

const { Search } = Input;
const { confirm } = Modal;
const MARGIN = 15;
const leftStyle = {
    float: "left",
    marginRight:"5px"
};
const rightStyle = {
    float: "right",
    marginLeft:"5px"
};

const PIC_TYPE = "jpg,jpeg,png,gif,bmp,JPG,JPEG,PNG,GIF,BMP";
const VIDEO_TYPE = "flv,avi,rmvb,mov,mp4,FLV,AVI,RMVB,MOV,MP4";
const AUDIO_TYPE = "webm,mp3,wav,mid,WEBM,MP3,WAV,MID";

//云存储中的类型
const STORAGE_TYPE_PIC = 1;
const STORAGE_TYPE_VIEDO = 2;
// const STORAGE_TYPE_OTHER = 3; 暂时注掉，代码中没有使用，不然编辑器一直警告
const STORAGE_TYPE_AUDIO = 4;
const FILE_PROPERTY = {
	height: {
		small:140,
		middle:200,
		big:300,
		list:140
	},
	showPic: {//显示的图片宽高
		small:56,
		middle:100,
		big:150,
		list:40
	}
};
let defaultHierarchy=2
//add 按钮 控制
let btnCtrlKey="up"; //新增按钮状态控制
let ctrlKey = "up";//ctrl键监听
let isMac = /macintosh|mac os x/i.test(navigator.userAgent);
let ctrlKeyCode = isMac?91:17;
const listenKeyDown = (e) => {//默认监听键盘按下事件
    let ev = e || window.event;
    if(ev.keyCode === ctrlKeyCode){
        ctrlKey = "down";
        btnCtrlKey = "down"
    }
};
const listenKeyUp = (e) => {//默认监听键盘抬起事件
    let ev = e || window.event;
    if(ev.keyCode === ctrlKeyCode){
        ctrlKey = "up";
        btnCtrlKey = "up"
    }
};

window.onkeydown = listenKeyDown;
window.onkeyup = listenKeyUp;
let picFiles=[];
//不要随便删除下面   global layer * 这个代码
/* global layer */
class StorageList extends Component {

    constructor(props){
        super(props);
        this.state = {
            directoryDatasource: this.props.directoryDatasource,
            fileDatasource: this.props.fileDatasource,
            currentId: this.props.currentId,
            checkedId: {
                directoryIds: "",
                fileIds: "",
                allIds: ""
            },
            moreVisible: false,
            storageDirectoryVisible: false,
            storageDirectoryLoading: false,
            showType: cookie.load("showType")?cookie.load("showType"):"small",//小图标  small middle big list
            backLists:[],
            history:require("history").createHashHistory(),
            moreBtn:false,
            radioValue:0,

        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        ctrlKey = "up";
        btnCtrlKey = "up";//
        this.setState({
            directoryDatasource: nextProps.directoryDatasource,
            fileDatasource: nextProps.fileDatasource,
            currentId: nextProps.currentId,
            storageDirectoryVisible: false,
            storageDirectoryLoading: false,
            moreBtn: false,
            radioValue:0
        })
    }

    componentDidMount(){
        window.addEventListener('resize', this.resize.bind(this));

    }

    //重新渲染调用，自适应
    resize(){
        this.setState({});
    }

    handleDoubleClick(storageDirectoryId){
        getStorageDirectoryList(storageDirectoryId, (data)=>{
          //  console.log(data)
            let ids = this.state.checkedId.allIds.split(",");
            ids.map(id=>{
                if(id){
                    //刷新子组件check 的方法
                    this.refs[id].unChecked();
                }
            })
            //console.log(this.state.backLists)//去的最后一个_id 刷新也调取这个
           // console.log('142点击某个文件夹或刷新后的获取的数据---------------',data)
            this.setState({
                directoryDatasource: data.directorys,
                fileDatasource: data.files,
                currentId: storageDirectoryId,
                checkedId: {
                    directoryIds: "",
                    fileIds: "",
                    allIds: ""
                },
            })
        });
    }

    componentWillUnmount(){
        window.removeEventListener('resize',this.resize)
    }

    //选中的文件夹与文件id
    updateCheckedId(id, type, op){
        if(op === "add"){
            // let fileCheckStatus = this.refs[id].state.checked;//改变之前的选中状态
            if (ctrlKey === "up") {
                this.state.moreBtn = false
                //更新radio 的状态，勿动
                this.state.radioValue=0
            } else {
                this.state.moreBtn = true
                this.state.radioValue=1
            }
            this.setState(prevState => {
                //弄成只能选中一个文件
                if(ctrlKey === "up"){
                    if(type === "directory"){
                        prevState.checkedId.directoryIds = id + ",";
                        prevState.checkedId.fileIds = "";
                    }else{
                        prevState.checkedId.directoryIds = "";
                        prevState.checkedId.fileIds = id + ",";
                    }
                    if(prevState.checkedId.allIds){//这里是为了阻止多选，所以加了一个方法。
                        let ids = prevState.checkedId.allIds.split(",");
                        ids.map(_id => {
                            if(this.refs[_id] && this.refs[_id].unChecked && _id!==id){
                                this.refs[_id].unChecked();
                            }
                            return _id;
                        });
                    }
                    prevState.checkedId.allIds = id + ",";
                }else{
                    if(type === "directory"){
                        prevState.checkedId.directoryIds += id + ",";
                    }else{
                        prevState.checkedId.fileIds += id + ",";
                    }
                    prevState.checkedId.allIds += id + ",";
                }
                return prevState;
            })
        }else{
            this.setState(prevState => {
                //sureChecked
                //如果选中了多个，并且当需要取消的这个
                if(type === "directory"){
                    prevState.checkedId.directoryIds = prevState.checkedId.directoryIds.replace(id + ",", "");
                }else{
                    prevState.checkedId.fileIds = prevState.checkedId.fileIds.replace(id + ",", "");
                }
                prevState.checkedId.allIds = prevState.checkedId.allIds.replace(id + ",", "");
                return prevState;
            })
        }
        return this.state.checkedId.allIds;
        // let that = this;
        // window.onkeydown = (e) =>{
        //     let ev = e || window.event;
        //     if(ev.keyCode === 113){//F2
        //         that.rename();
        //     }
        // }
    }

    rename(){
        this.hiddenMoreVisible();
        if(this.state.checkedId.allIds){
            //永远只是改第一个
            let id = this.state.checkedId.allIds.replace(/^([^,]+),.*/, "$1");
            this.refs[id].rename((newName)=>{
                if(newName){//说明改名了
                    this.setState(prevState => {
                        prevState.directoryDatasource.map(item => {
                            if(item._id === id){
                                item.name =  newName;
                            }
                            return item;
                        });
                        prevState.fileDatasource.map(item => {
                            if(item._id === id){
                                item.name =  newName;
                            }
                            return item;
                        });
                        return prevState;
                    })
                }
            });
        }else{
            message.error("请至少选择一个文件或文件夹!");
        }
    }

    createStorageDirectory(){
        let prevState = Object.assign({},this.state);
        let directoryName = "新建文件夹";
        if(prevState.directoryDatasource.length > 0){
            let allIndex = "";
            let maxIndex = prevState.directoryDatasource.length;
            for(let i = 1 ; i < maxIndex + 1; i++){
                allIndex += i + ",";
            }
            let oldAllIndex = allIndex;
            prevState.directoryDatasource.map(item => {
                if(item.name === "新建文件夹"){
                    allIndex = allIndex.replace("1,", "");
                }else {
                    let resultIndex = item.name.replace(/^新建文件夹（(\d+)）$/, "$1");
                    if(!isNaN(parseInt(resultIndex))){
                        allIndex = allIndex.replace(parseInt(resultIndex) + ",", "");
                    }
                }
            });
            console.log(allIndex,oldAllIndex)
            if(allIndex === oldAllIndex){
                directoryName = "新建文件夹";
            }else if(allIndex === ""){
                directoryName = "新建文件夹（"+(prevState.directoryDatasource.length+1)+"）";
            }else{
                directoryName = "新建文件夹（"+allIndex.replace(/^(\d+),.*/, "$1")+"）";
            }
            if(directoryName === "新建文件夹（1）"){
                directoryName = "新建文件夹";
            }
        }
        let that = this;
        createStorageDirectory(directoryName, prevState.currentId, (data)=>{
            that.setState(prevState => {
                prevState.directoryDatasource.push(data);
                return prevState;
            })
        });
    }

    handleUpload = info => {
        let fileList = [...info.fileList];
        let fileDatasource = Object.assign(this.state.fileDatasource, {});
        fileList = fileList.map(file => {
            let isAdd = true;//是否要加入上传队列中
            fileDatasource.map(item =>{
                if(item.uid === file.uid ){//如果之前这个待上传的文件已经加入了文件源中.
                    isAdd = false;
                    if(file.status === "done"){  //如果这个文件上传完。要把临时的上传文件替换为上传后的文件
                        item.md5 = file.response.storageFile.md5
                        // item.url.smallUrl = file.response.smallUrl;
                        fileToDirectory(item.md5, this.state.currentId, ()=>{});
                    }
                }
            });
            if(isAdd){
                let uploadingFile = {
                    name:file.name,
                    uid: file.uid,
                    md5:file.uid,
                    url:{
                        smallUrl:"images/loading.gif"
                    },
                    isUpload:true
                };
                fileDatasource.push(uploadingFile);
            }
            return file;
        });


        this.setState({
            fileDatasource,
            fileList ,
        });
    };

    gotoSearch = (searchStr) => {
        if(searchStr){
            search(searchStr, this.state.currentId,(dataSource)=>{
                this.setState({
                    directoryDatasource: dataSource.directorys,
                    fileDatasource: dataSource.files,
                    checkedId: {
                        directoryIds: "",
                        fileIds: "",
                        allIds: ""
                    },
                })
            });
        }else{
            getStorageDirectoryList(this.state.currentId, (dataSource)=>{
                this.setState({
                    directoryDatasource: dataSource.directorys,
                    fileDatasource: dataSource.files,
                    checkedId: {
                        directoryIds: "",
                        fileIds: "",
                        allIds: ""
                    },
                })
            });
        }
    };

    gotoBatchDownload = () => {
        let that=this;
        if (this.state.checkedId.allIds) {
            let directoryIds = this.state.checkedId.directoryIds.replace(/(.*),$/, '$1');
            let fileIds = this.state.checkedId.fileIds.replace(/(.*),$/, '$1');
            let params = {
                directoryIds,
                fileIds
            }
            getBatchDownloadPath(params, function(data) {
                if(data.code===2){
                    // message.success("请到我的下载，去下载文件");
                    Modal.confirm({
                        title: '已成功添加下载队列',
                        content: '请前往“我的下载”页面查看下载',
                        okText:"确定前往",
                        cancelText:'关闭',
                        icon:<Icon type="check-circle" />,
                        onOk() {that.state.history.push("/library/download/downloadList"); },
                        onCancel(){}
                    });
                }
            })
        } else {
            message.error("请至少选择一个文件或文件夹!");
        }
    };

    gotoRecycle = ()=>{
        this.hiddenMoreVisible();
        let that = this;
        if(this.state.checkedId.allIds) {
            let fileIds = that.state.checkedId.fileIds.replace(/(.*),$/, '$1');
            let md5s = [];
            fileIds.split(",").map(item=>{
                if(item){
                    md5s.push(that.refs[item].props.md5);
                }
            });

            confirm({
                title: '确定要将所选项移至回收站?',
                onOk() {
                    let directoryIds = that.state.checkedId.directoryIds.replace(/(.*),$/, '$1');
                    moveToRecycle(directoryIds, fileIds, md5s.join(","), ()=>{
                        getStorageDirectoryList(that.state.currentId, (dataSource)=>{
                            that.setState({
                                directoryDatasource: dataSource.directorys,
                                fileDatasource: dataSource.files,
                                checkedId: {
                                    directoryIds: "",
                                    fileIds: "",
                                    allIds: ""
                                },
                            })
                        });
                    });
                },
                onCancel() {
                    that.setState({confirmVisible:false});
                },
            });
        }else {
            message.error("请至少选择一个文件或文件夹!");
        }
    };

    handleOk(id){
        let that = this;
        let directoryIds = that.state.checkedId.directoryIds.replace(/(.*),$/, '$1');
        let fileIds = that.state.checkedId.fileIds.replace(/(.*),$/, '$1');
        moveByDirectoryIdsAndFileIds(directoryIds, fileIds, id, ()=>{
            getStorageDirectoryList(that.state.currentId, (dataSource)=>{
                that.setState({
                    directoryDatasource: dataSource.directorys,
                    fileDatasource: dataSource.files,
                    checkedId: {
                        directoryIds: "",
                        fileIds: "",
                        allIds: ""
                    },
                    storageDirectoryVisible: false,
                    storageDirectoryLoading: false
                })
            });
        });
    };

    handleCancel(){
        this.setState({
            storageDirectoryVisible: false,
            storageDirectoryLoading: false
        })
    };

    move = ()=>{
        this.hiddenMoreVisible();
        let that = this;
        if(this.state.checkedId.allIds) {
            that.setState({
                storageDirectoryVisible: true
            })
        }else {
            message.error("请至少选择一个文件或文件夹!");
        }
    };

    addRelationDept(){
        this.hiddenMoreVisible();
        let that = this;
        if(this.state.checkedId.allIds) {
            let url = '/cm-sites/pms/library/showDept.html?';
            window.layer.open({
                title: '设置相关部门',
                type: 2,
                content: url,
                area : ['411px', '570px'],
                resize : false,
                shade : 0.001,	//遮罩
                btn: ['保存', '取消'],
                yes: function (index, layero) {
                    let openPage = window[layero.find('iframe')[0]['name']];
                    let node = openPage.getCheckedNodes();
                    let nodeResult = "";
                    let newRelatedDeptIds = [];
                    if(node.length > 0){
                        for(let j = 0; j < node.length; j ++){
                            if(j===0)
                                nodeResult = node[j].id;
                            else
                                nodeResult = nodeResult + ',' + node[j].id;
                            newRelatedDeptIds[j] = node[j].id;
                        }
                    }

                    let fileIds = that.state.checkedId.fileIds.replace(/(.*),$/, '$1');
                    let md5s = [];
                    fileIds.split(",").map(item=>{
                        if(item){
                            md5s.push(that.refs[item].props.md5);
                        }
                    });

                    let directoryIds = that.state.checkedId.directoryIds.replace(/(.*),$/, '$1');
                    let loadIndex = layer.load(2);
                    addRelatedDeptIds(md5s.join(), directoryIds, newRelatedDeptIds.join(), ()=>{
                        layer.close(loadIndex);
                        layer.close(index);
                    })
                },btn2: function (index, layero) {//取消按钮
                }
            });
        }else {
            message.error("请至少选择一个文件或文件夹!");
        }
    }

    openSearchDialogBtnName = "打开多功能搜索引擎";

    //上传压缩包 参考的1065代码
    showCompressedPackageUploadDialog  (){
        let currentFile;
        let allFpath="";
        if(this.state.backLists&&this.state.backLists.length>0){
            // currentFile= this.state.backLists[this.state.backLists.length-1]
            for(let i=0;i<this.state.backLists.length;i++){
                allFpath+=this.state.backLists[i].name+"/";
            }
        }
        console.log('当前文件层级',this.state.backLists)

        let x = "750px";
        let y = "495px";
        let that = this;
        window.layer.open({
            title: '上传压缩包',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&resourceType=6&onlyUploadFile=true',
            area: [x, y],
            resize: false,
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            success: function(layero, index){
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#myAlert").show();
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.onlySaveUploadZipFile(allFpath, function (index, obj) {
                    let loadIndex = window.layer.load();
                    getStorageDirectoryList(that.state.currentId, (dataSource)=>{
                        that.setState({
                            directoryDatasource: dataSource.directorys,
                            fileDatasource: dataSource.files,
                            checkedId: {
                                directoryIds: "",
                                fileIds: "",
                                allIds: ""
                            },
                            storageDirectoryVisible: false,
                            storageDirectoryLoading: false
                        })
                        window.layer.close(loadIndex);
                    });
                    window.layer.close(index);
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    };

    showMoreVisible()
    {
        this.setState({
            moreVisible: true,
        })
    }

    hiddenMoreVisible() {
        this.setState({
            moreVisible: false,
        })
    }

    handleVisibleChange = visible => {
        this.setState({ moreVisible:visible });
    };
    renderBtn(){
        let isHiddenBtn = window.document.body.clientWidth <= 1420;
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        newSecondSelectColor=this.props.newSecondSelectColor;
       // console.log('--------------',this.props,this.props.config)
        return (
            <div>
                <Button style={{...leftStyle,  background: newSecondSelectColor,
                            borderColor: newSecondSelectColor}} type={"primary"} icon={"cloud-upload"} onClick={(e)=>this.showOnlyFileUploadDialog(e)}>上传文件</Button>
                <Button style={{...leftStyle,  background: newSecondSelectColor,
                            borderColor: newSecondSelectColor}} type={"primary"} icon={"cloud-upload"} onClick={(e)=>{
                    this.showCompressedPackageUploadDialog()

                }}>上传压缩包</Button>
                <Button icon={"download"} style={{...leftStyle}} onClick={()=>this.gotoBatchDownload()}>下载文件</Button>
                <Button icon={"folder-add"} onClick={(e)=>this.createStorageDirectory(e)} style={{...leftStyle}}>新建文件夹</Button>
                {isHiddenBtn?<span></span>:<Button style={{...leftStyle}} onClick={(e)=>this.move(e)}>移动至</Button>}
                {isHiddenBtn?<span></span>:<Button style={{...leftStyle}} onClick={(e)=>this.rename(e)}>重命名</Button>}
                {isHiddenBtn?<span></span>:<Button style={{...leftStyle}} onClick={()=>this.gotoRecycle()}>删除</Button>}
                {isHiddenBtn?<span></span>:<Button style={{...leftStyle}} onClick={()=>{
                    let id;
                    if(this.state.backLists&&this.state.backLists.length>0){
                        id= this.state.backLists[this.state.backLists.length-1]._id
                    }
                    //console.log(id)
                    this.handleDoubleClick(id)
                }}>刷新</Button>}
                <Popover placement="rightTop"
                         visible={this.state.moreVisible}
                         onVisibleChange={this.handleVisibleChange}
                         content={<div>
                             {isHiddenBtn?<Radio.Group style={{marginTop:5}}  onChange={(e)=>{
                                 let targetValue=e.target.value
                                 if(targetValue===0){
                                     btnCtrlKey = "up"
                                     ctrlKey = "up"
                                     this.state.moreBtn = false
                                 }
                                 //多选
                                 if(targetValue===1){
                                     btnCtrlKey = "down"
                                     ctrlKey = "down"
                                     this.state.moreBtn = true
                                     message.warning('按下ctrl不放，也能实现多选文件')
                                 }else{
                                     btnCtrlKey = "up"
                                     ctrlKey = "up"
                                     this.state.moreBtn = false
                                 }
                                 //全选
                                 if(targetValue===2){
                                     this.getAllChoose()
                                 }
                                 //反选
                                 if(targetValue===3){
                                     this.getReverseSelection()
                                 }
                                 this.state.radioValue=targetValue
                                 this.setState({})
                             }} value={this.state.radioValue}>
                                 <Radio value={0}>单选</Radio>
                                 <Radio value={1}>多选</Radio>
                                 <Radio value={2}>全选</Radio>
                                 <Radio value={3}>反选</Radio>
                             </Radio.Group>:<span></span>}

                             {isHiddenBtn?<br />:<span></span>}
                             {isHiddenBtn?<Button style={{marginTop:10}}  onClick={(e)=>this.move(e)}>移动至</Button>:<span></span>}
                             {isHiddenBtn?<br />:<span></span>}
                             {isHiddenBtn?<Button style={{"marginTop":"10px"}} onClick={(e)=>this.rename(e)}>重命名</Button>:<span></span>}
                             {isHiddenBtn?<br />:<span></span>}
                             {isHiddenBtn?<Button style={{"marginTop":"10px"}} onClick={()=>this.gotoRecycle()}>删除</Button>:<span></span>}
                             {isHiddenBtn?<br />:<span></span>}
                             {isHiddenBtn?<Button   style={{"marginTop":"10px"}} onClick={()=>{
                                 let id;
                                 if(this.state.backLists&&this.state.backLists.length>0){
                                     id= this.state.backLists[this.state.backLists.length-1]._id
                                 }
                                 //console.log(id)
                                 this.handleDoubleClick(id)
                             }}>刷新</Button>:<span></span>}
                             {isHiddenBtn?<br />:<span></span>}
                             {isHiddenBtn?<Button style={{"marginTop":"10px"}} title={"可以给文件夹下所有子文件添加标签，也可以直接给文件添加标签"} onClick={(e)=>this.addLabel(e)}>文件或文件夹下的子文件追加标签</Button>:
                                 <Button title={"可以给文件夹下所有子文件添加标签，也可以直接给文件添加标签"} onClick={(e)=>this.addLabel(e)}>文件或文件夹下的子文件追加标签</Button>}
                             <br />
                             <Button style={{"marginTop":"10px"}} title={"可以给文件夹下所有子文件设置相关部门，也可以直接给文件设置相关部门"} onClick={(e)=>this.addRelationDept(e)}>覆盖文件或文件夹下的子文件的相关部门</Button>
                         </div>} trigger="click">
                    <Button icon={"more"}
                            style={{...leftStyle }}
                            onClick={this.showMoreVisible.bind(this)}></Button>
                </Popover>
                <Search
                    placeholder="请输入文件名"
                    style={{...leftStyle, width: 200 }}
                    onSearch={searchStr => this.gotoSearch(searchStr)}
                />
                {isHiddenBtn?<span></span>:  <Radio.Group style={{marginTop:5}}  onChange={(e)=>{
                    let targetValue=e.target.value
                    if(targetValue===0){
                        btnCtrlKey = "up"
                        ctrlKey = "up"
                        this.state.moreBtn = false
                    }
                    //多选
                    if(targetValue===1){
                        btnCtrlKey = "down"
                        ctrlKey = "down"
                        this.state.moreBtn = true
                        message.warning('按下ctrl不放，也能实现多选文件')
                    }else{
                        btnCtrlKey = "up"
                        ctrlKey = "up"
                        this.state.moreBtn = false
                    }
                    //全选
                    if(targetValue===2){
                        this.getAllChoose()
                    }
                    //反选
                    if(targetValue===3){
                        this.getReverseSelection()
                    }
                    this.state.radioValue=targetValue
                    this.setState({})
                }} value={this.state.radioValue}>
                    <Radio value={0}>单选</Radio>
                    <Radio value={1}>多选</Radio>
                    <Radio value={2}>全选</Radio>
                    <Radio value={3}>反选</Radio>
                </Radio.Group>}
                <Button
                    type={"dashed"}
                    icon={"appstore"}
                    style={{...rightStyle}}
                    onClick={()=>this.openSearchDialog()}
                >{this.openSearchDialogBtnName}</Button>
                <StorageDirectory
                    visible={this.state.storageDirectoryVisible}
                    handleOk={(id)=>this.handleOk(id)}
                    confirmLoading={this.state.storageDirectoryLoading}
                    handleCancel ={()=>this.handleCancel()}
                />
                <div style={{clear:'both'}}/>
            </div>);
    }
    //全选
    getAllChoose(){
        let directoryDatasource = this.state.directoryDatasource//当前页所有文件夹
        let fileDatasource = this.state.fileDatasource //当前页的所有文件
        let directoryIds = this.state.checkedId.directoryIds //所有的文件夹的id
        let fileIds = this.state.checkedId.fileIds //所有文件的id
        let allIds = this.state.checkedId.allIds //所有的的id
        //获取所有文件夹id 放到对应选中里面
        if (directoryDatasource.length && directoryDatasource.length > 0) {
            directoryDatasource.forEach((item, i) => {
                directoryIds = directoryIds + item._id + ','
                allIds = allIds + item._id + ','
            })
        }
        //获取所有文件的id
        if (fileDatasource.length && fileDatasource.length > 0) {
            fileDatasource.forEach((item, i) => {
                fileIds = fileIds + item._id + ','
                allIds = allIds + item._id + ','
            })
        }
        let ids = allIds.split(",");
        ids.map(id=>{
            if(id){
                //刷新子组件check 的方法
                this.refs[id].ToChecked();
            }
        })

        this.setState({
            checkedId: {
                directoryIds: directoryIds,
                fileIds: fileIds,
                allIds: allIds
            }
        })

    //console.log('全选',directoryDatasource,fileDatasource,this.state.currentId,this.state.checkedId)
    }
   //反选
    getReverseSelection() {
        let directoryDatasource = this.state.directoryDatasource//当前页所有文件夹
        let fileDatasource = this.state.fileDatasource //当前页的所有文件
        //let directoryIds = this.state.checkedId.directoryIds.split(",") //当前选中的的文件夹的id
        // let fileIds = this.state.checkedId.fileIds.split(",") //当前选中文件的id
        let allIds = this.state.checkedId.allIds.split(",") //当前选中的所有的的id
        let unDirectoryIds = '' //当前未选中的文件夹的id
        let unFileIds = '' //当前未选中的文件的id
        let unAllIds = '' //当前未选中的所有的的id
        //去除所有的选中，把所有的选中全部百年城为选中unChecked
        let ids = allIds;
        ids.map(id => {
            if (id) {
                //刷新子组件check 的方法
                this.refs[id].unChecked();
            }
        })

        //获取所有文件夹id 放到对应选中里面
        if (directoryDatasource.length && directoryDatasource.length > 0) {
            directoryDatasource.forEach((item, i) => {
                if (!allIds.includes(item._id)) {
                    unDirectoryIds = unDirectoryIds + item._id + ','
                    unAllIds = unAllIds + item._id + ','
                }
            })
        }
        //获取所有文件的id
        if (fileDatasource.length && fileDatasource.length > 0) {
            fileDatasource.forEach((item, i) => {
                if (!allIds.includes(item._id)) {
                    unFileIds = unFileIds + item._id + ','
                    unAllIds = unAllIds + item._id + ','
                }
            })
        }
        //把未选中的文件夹全部选中。
        let unIds = unAllIds.split(",");
        unIds.map(id => {
            if (id) {
                //刷新子组件check 的方法
                this.refs[id].ToChecked();
            }
        })
       // console.log('未选中多个数据', directoryDatasource, fileDatasource, 'unDirectoryIds-------', unDirectoryIds, 'unFileIds---------', unFileIds, 'unAllIds----', unAllIds)
        //更新值状态
        this.setState({
            checkedId: {
                directoryIds: unDirectoryIds,
                fileIds: unFileIds,
                allIds: unAllIds
            }
        })
    }

    openSearchDialog(){}

    calcContentArea(){
        let allWidth = window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH - 10*2 - MARGIN*2;
        let blockWidth = 176;
        let blockHeight = FILE_PROPERTY.height[this.props.showType];
        let count = this.state.directoryDatasource.length + this.state.fileDatasource.length;

        let colsMaxCount = Math.floor(allWidth / blockWidth);//最大列数
        let rowsCount = Math.ceil(count / colsMaxCount);//行数

        let allHeight = rowsCount * blockHeight;
        return [allWidth, allHeight];
    }

    addLabel(e){
        this.hiddenMoreVisible();
        if(this.state.checkedId.allIds){
            let directoryIds = this.state.checkedId.directoryIds.replace(/(.*),$/, '$1');
            let fileIds = this.state.checkedId.fileIds.replace(/(.*),$/, '$1');
            let md5s = [];
            let that = this;
            fileIds.split(",").map(item=>{
                if(item){
                    md5s.push(that.refs[item].props.md5);
                }
            });

            window.layer.open({
                title: '批量添加标签',
                type: 2,
                shade: 0.8,
                content: '/cm-sites/' + applicationName() + '/library/upload/writeLabel.html',
                area: ["800px", "200px"],
                btn: ['保存', '关闭'],
                cancel: function (index, layero) {
                    window.layer.close(index);
                },
                end: function (index, layero) {
                },
                yes: function (index, layero) {
                    let openPage = window[layero.find('iframe')[0]['name']];
                    if(openPage.labelNames!==""){
                        let loadIndex = window.layer.load();
                        addLabel(directoryIds, md5s.join(","), openPage.labelNames, ()=>{
                            window.layer.close(loadIndex);
                        });
                    }
                    window.layer.close(index);
                }
            });
        }else{
            message.error("请至少选择一个文件或文件夹!");
        }
    }

    addStorageDirectoryLabel(){
        let that = this;
        if(this.state.currentId){
            window.layer.open({
                title: '配置当前文件夹默认标签',
                type: 2,
                shade: 0.8,
                content: '/cm-sites/' + applicationName() + '/library/upload/writeStorageLabel.html',
                area: ["800px", "200px"],
                btn: ['保存', '关闭'],
                success: function(layero, index){
                    let openPage = window[layero.find('iframe')[0]['name']];
                    let loadIndex = window.layer.load();
                    getStorageDirectory(that.state.currentId, (data)=>{
                        if(data.labels){
                            openPage.tagData.initLabelNames(data.labels.split(","));
                            openPage.tagData.showLabelNames("mf_label", "add-mf-tags");
                        }
                        window.layer.close(loadIndex);
                    });
                },
                cancel: function (index, layero) {
                    window.layer.close(index);
                },
                end: function (index, layero) {
                },
                yes: function (index, layero) {
                    let openPage = window[layero.find('iframe')[0]['name']];
                    if(openPage.labelNames!==""){
                        let loadIndex = window.layer.load();
                        setDirectoryLabels(that.state.currentId, openPage.labelNames,()=>{
                            window.layer.close(loadIndex);
                        });
                    }
                    window.layer.close(index);
                }
            });
        }else{
            message.error("系统错误!");
        }
    }

    changeShowType(e){
        cookie.save('showType', e.target.value);
        if(e.target.value == "list"){
            this.setState({
                showType: e.target.value
            });
        }else{
            this.setState({
                showType: e.target.value
            });
        }
    }

   renderBackLists = ()=>{
       defaultHierarchy=2
    };

    renderHead(){
        return(
            <div style={{width:"100%", height:"42px", borderBottom:"1px solid #e1e1e1"}}>
                <span style={{lineHeight:"42px",fontSize:"14px", color:"#333", marginLeft:"10px"}}>{this.props.title}</span>
            </div>
        )
    }

    renderPosition(){
        return <Position
            onClick={(id)=>{
                this.handleDoubleClick(id)}}
            callBackList={(list)=>{
                this.setState({backLists:list})
            }}
            currentId={this.state.currentId}/>;
    }

    render() {
        let area = this.calcContentArea();
        console.log("defaultHierarchy:   ", defaultHierarchy, "this.state.backLists:  ", this.state.backLists);
       /* let fileHeight=document.body.clientHeight-70-20-42-20- $('.btnOrProcess').height();//减去最上面head 70-全部文件20-面包削全部文件42-底部20；减去上传按钮动态高度。
        console.log(filesToDirectory())*/
        return (
            <div style={{height:"calc(100vh - 100px)",margin: MARGIN + "px", background:"#fff",overflow: 'hidden',position: 'relative'}}>
              {this.renderHead()}
                <div style={{padding:10,height:"calc(100% - 42px)",overflowY: 'auto',overflowX:'hidden'}}>
                    <div className={'btnOrProcess'}>
                        {this.renderBtn()}
                        <div style={{clear:"both"}}>
                            <div style={{lineHeight: "50px" , height:"50px", ...leftStyle}}>
                                {this.renderBackLists()}
                              {this.state.backLists&&this.state.backLists.length>defaultHierarchy?<span onClick={()=>{
                                    let id=this.state.backLists[this.state.backLists.length-2]._id
                                    this.handleDoubleClick(id)
                                }} style={{cursor:'pointer',color:'rgb(24, 144, 255)'}}>返回上一级&nbsp;</span>:null}

                                {this.state.backLists&&this.state.backLists.length>defaultHierarchy?'|':null}&nbsp;当前位置：
                                {this.renderPosition()}
                            </div>
                            <div style={{lineHeight: "50px" , height:"50px", ...rightStyle}}>
                                共：{this.state.directoryDatasource.length}个文件夹，{this.state.fileDatasource.length}个文件


                                <Popover placement="leftTop"
                                         content={<div>
                                             <Radio.Group onChange={this.changeShowType.bind(this)} value={this.state.showType}>
                                                 <Radio value={"small"}>小图标</Radio><br/>
                                                 <Radio value={"middle"}>中图标</Radio><br/>
                                                 <Radio value={"big"}>大图标</Radio><br/>
                                                 <Radio value={"list"}>列表</Radio><br/>
                                             </Radio.Group>
                                         </div>} trigger="click">
                                    <Button icon={"appstore"} style={{marginLeft:"5px"}}></Button>
                                </Popover>
                                {/*<img style={{marginLeft:"5px",cursor:"pointer", marginTop:"-3px", height:"17px", width:"17px"}} src={this.state.isListDisplay?"images/u1906.png":"images/u1651.png"} onClick={()=>this.handleListDisplay()}/>*/}
                            </div>
                            <div style={{clear:'both'}}/>
                        </div>
                    </div>
                    <div style={{width:'100%'}}>
                        {/*this.props.match.params.resourceComponent === "PluginStoragePicList"?"100%": area[0] + "px"*/}
                        <div style={{ width:'100%', height: area[1] + "px",cursor:'pointer'}}>
                            {this.state.directoryDatasource.map(item =>{
                                return <Directory ref={item._id}
                                                  checkedFun={(id)=>this.updateCheckedId(id, "directory", "add")}
                                                  unCheckedFun={(id)=>this.updateCheckedId(id, "directory", "remove")}
                                                  onDoubleClick={(e)=>this.handleDoubleClick(item._id)} {...item} key={item._id}
                                                  showType={this.state.showType} />
                            })}
                            {this.renderResource && this.renderResource()  }
                            <div style={{clear:'both'}}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

StorageList.defaultProps = {
    title: "全部文件",
    //position:"全部图片",
    directoryCount:0,
    fileCount: 0,
    directoryDatasource:[
        {"_id":"5df981142aa89c00079a2e03","fid":"","name":"2018年","path":"", "checked":false},
        {"_id":"5df982c32aa89c00079a2e05","fid":"","name":"2019年","path":"", "checked":false},
        {"_id":"5df982c32aa89c00079a2e01","fid":"","name":"撒大华府金沙啊士大夫艰苦和年","path":"", "checked":false},
        {"_id":"5df982c32aa89c00079a2e02","fid":"","name":"撒大华府金沙啊撒旦发射点发生阀手动阀阿斯蒂发士大夫艰苦和年","path":"", "checked":false}
    ],
    fileDatasource:[],
};
function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(StorageList);

export class StoragePicList extends StorageList{

    openSearchDialogBtnName = "打开图片多功能搜索引擎";


    showOnlyFileUploadDialog(){
        let x = "750px";
        let y = "495px";
        let that = this;
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&resourceType=2&onlyUploadFile=true',
            area: [x, y],
            resize: false,
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            success: function(layero, index){
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#myAlert").show();
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.onlySaveFile("", function (index, obj) {
                    let loadIndex = window.layer.load();
                    let uploadingFiles = [];
                    let md5sParam = [];
                    if (openPage.tempResultsNew) {
                        openPage.tempResultsNew.map(item => {
                            md5sParam.push(item.storageFile.md5);
                            let uploadingFile = {
                                _id: item.storageFile._id,
                                name: item.storageFile.name,
                                md5: item.storageFile.md5,
                                url: {
                                    middleUrl:item.middleUrl,
                                    smallUrl:item.smallUrl,
                                    url:item.url,
                                }
                            };
                            uploadingFiles.push(uploadingFile);
                        });
                    }

                    getStorageDirectory(that.state.currentId, (data)=>{
                        if(data.labels){
                            fileToDirectoryAndAddLabel(md5sParam.join(), that.state.currentId, data.labels, ()=>{
                                window.layer.close(loadIndex);
                                // that.setState(prevState=>{
                                //     uploadingFiles.map(uploadingFile=>{
                                //         prevState.fileDatasource.push(uploadingFile);
                                //     });
                                //     return prevState;
                                // });
                                //触发刷新页面
                                console.log(that)
                                let id;
                                if(that.state.backLists&&that.state.backLists.length>0){
                                    id= that.state.backLists[that.state.backLists.length-1]._id
                                }
                                //console.log(id)
                                that.handleDoubleClick(id)
                            });
                        }else{
                            filesToDirectory(md5sParam.join(), that.state.currentId, ()=>{
                                window.layer.close(loadIndex);
                                // that.setState(prevState=>{
                                //     uploadingFiles.map(uploadingFile=>{
                                //         prevState.fileDatasource.push(uploadingFile);
                                //     });
                                //     return prevState;
                                // });
                                //触发刷新页面
                                console.log(that)
                                let id;
                                if(that.state.backLists&&that.state.backLists.length>0){
                                    id= that.state.backLists[that.state.backLists.length-1]._id
                                }
                                //console.log(id)
                               that.handleDoubleClick(id)

                            });
                        }
                    });
                    window.layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    }

    showUploadDialog = ()=>{
        let that = this;
        let x = "930px";
        let y = "640px";
        if (applicationName() == "pms") {
            x = "750px";
            y = "680px";
        }
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&resourceType=2',
            area: [x, y],
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.saveTempFile(function (index, obj) {
                    window.layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    };

    openSearchDialog(){
        window.layer.open({
            title: '图片多功能搜索引擎',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/picture/pictureList.html',
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px',parseInt(window.document.body.clientHeight * 0.9) + 'px'],
            resize: false,
        });
    }

    renderResource(){
        //让图片预览获取；
        picFiles=this.state.fileDatasource;
        return this.state.fileDatasource.map(item =>{
            let type = item.name.replace(/.*\.([a-zA-Z1-9]*$)/, "$1");
            if(PIC_TYPE.indexOf(type) !== -1){
                return <Picture ref={item._id}
                                baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                                baseHeight={window.$(window).height() - HEADER_HEIGHT}
                                offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                                offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                                checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                                unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                                click={(id)=>this.updateCheckedId(id)}
                                {...item} key={item._id}
                                showType={this.state.showType} />
            }
            return <Other ref={item._id}
                          baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                          baseHeight={window.$(window).height() - HEADER_HEIGHT}
                          offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                          offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                          checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                          unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                          click={(id)=>this.updateCheckedId(id)}
                          {...item} key={item._id}
                          showType={this.state.showType} />
        })
    }
}

export class PluginStoragePicList extends StoragePicList {
    //隐藏头部
    renderHead() {
        return (
            <div></div>
        );
    }

    //是插件的时候隐藏头部按钮
    renderBtn() {
        /* let isHiddenBtn = window.document.body.clientWidth <= 1420;*/

        let newSecondSelectColor = this.state.newSecondSelectColor?this.state.newSecondSelectColor:this.props.this.state.newSecondSelectColor;
        return (
            <div>
                <Button style={{...leftStyle, background: newSecondSelectColor,
                            borderColor: newSecondSelectColor}} type={"primary"} icon={"cloud-upload"}
                        onClick={(e) => this.showOnlyFileUploadDialog(e)}>上传文件</Button>
                <Button icon={"folder-add"} onClick={(e) => this.createStorageDirectory(e)}
                        style={{...leftStyle}}>新建文件夹</Button>
                <Button type='primary' style={{float:'right', background: newSecondSelectColor,
                            borderColor: newSecondSelectColor}} onClick={() => {
                    this.synchronization()
                }}>同步</Button>
                <StorageDirectory
                    visible={this.state.storageDirectoryVisible}
                    handleOk={(id) => this.handleOk(id)}
                    confirmLoading={this.state.storageDirectoryLoading}
                    handleCancel={() => this.handleCancel()}
                />
            </div>);
    }

    synchronization() {
        let host = window.location.origin + "/cm-sites-pms/storage/";
        // let directorys = this.state.directoryDatasource;//所有的文件夹
        let files = this.state.fileDatasource;//所有的文件
        let checkedId = this.state.checkedId.allIds;//所有的选中的文件文件的_id
        let fileIds = this.state.checkedId.fileIds.split(",");//所有的选中的文件的_id
        //取出所有文件的，Md5
        files.forEach((item, i) => {
            if (fileIds.includes(item._id)) {
                window.parent.postMessage({
                    fun: "inputZykPicture2Xiumi",
                    args: [host + item.md5]
                }, '*');
            }
        });
        let ids = this.state.checkedId.allIds.split(",");
        ids.map(id => {
            if (id) {
                //刷新子组件check 的方法
                this.refs[id].unChecked();
            }
        });
        this.setState({
            checkedId: {
                directoryIds: "",
                fileIds: "",
                allIds: ""
            }
        })
    }
}

export class StorageVideoList extends StorageList{

    openSearchDialogBtnName = "打开视频多功能搜索引擎";

    showOnlyFileUploadDialog(){
        let x = "750px";
        let y = "495px";
        let that = this;
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&resourceType=3&onlyUploadFile=true',
            area: [x, y],
            resize: false,
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            success: function(layero, index){
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#myAlert").show();
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.onlySaveFile("", function (index, obj) {
                    let loadIndex = window.layer.load();

                    let uploadingFiles = [];
                    let md5sParam = [];
                    if (openPage.tempResultsNew) {
                        openPage.tempResultsNew.map(item => {
                            md5sParam.push(item.storageFile.md5);
                            let uploadingFile = {
                                _id: item.storageFile._id,
                                name: item.storageFile.name,
                                md5: item.storageFile.md5,
                                url: {
                                    thumbnailsURL:item.thumbnailsURL,
                                    url:item.url,
                                }
                            };
                            uploadingFiles.push(uploadingFile);
                        });
                    }

                    getStorageDirectory(that.state.currentId, (data)=>{
                        if(data.labels){
                            fileToDirectoryAndAddLabel(md5sParam.join(), that.state.currentId, data.labels, ()=>{
                                window.layer.close(loadIndex);
                                that.setState(prevState=>{
                                    uploadingFiles.map(uploadingFile=>{
                                        prevState.fileDatasource.push(uploadingFile);
                                    });
                                    return prevState;
                                });
                            });
                        }else{
                            filesToDirectory(md5sParam.join(), that.state.currentId, ()=>{
                                window.layer.close(loadIndex);
                                that.setState(prevState=>{
                                    uploadingFiles.map(uploadingFile=>{
                                        prevState.fileDatasource.push(uploadingFile);
                                    });
                                    return prevState;
                                });
                            });
                        }
                    });
                    window.layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    }

    showUploadDialog = ()=> {
        let that = this;
        let x = "930px";
        let y = "640px";
        if (applicationName() == "pms") {
            x = "750px";
            y = "680px";
        }
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&resourceType=3',
            area: [x, y],
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.saveTempFile(function (index, obj) {
                    layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    };

    openSearchDialog(){
        window.layer.open({
            title: '视频多功能搜索引擎',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/video/videoList.html',
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px',parseInt(window.document.body.clientHeight * 0.9) + 'px'],
            resize: false,
        });
    }

    renderResource(){
        return this.state.fileDatasource.map(item =>{

            let type = item.name.replace(/.*\.([a-zA-Z1-9]*$)/, "$1");
            if(VIDEO_TYPE.indexOf(type) !== -1){
                return <Video ref={item._id}
                              baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                              baseHeight={window.$(window).height() - HEADER_HEIGHT}
                              offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                              offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                              checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                              unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                              click={(id)=>this.updateCheckedId(id)}
                              {...item} key={item._id}
                              showType={this.state.showType} />
            }

            return <Other ref={item._id}
                          baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                          baseHeight={window.$(window).height() - HEADER_HEIGHT}
                          offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                          offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                          checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                          unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                          click={(id)=>this.updateCheckedId(id)}
                          {...item} key={item._id}
                          showType={this.state.showType} />
        })
    }
}

export class StorageAudioList extends StorageList{

    openSearchDialogBtnName = "打开音频多功能搜索引擎";

    openSearchDialog(){
        window.layer.open({
            title: '音频多功能搜索引擎',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/audio/audioList.html',
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px',parseInt(window.document.body.clientHeight * 0.9) + 'px'],
            resize: false,
        });
    }

    showOnlyFileUploadDialog(){
        let x = "750px";
        let y = "495px";
        let that = this;
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&resourceType=5&onlyUploadFile=true',
            area: [x, y],
            resize: false,
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            success: function(layero, index){
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#myAlert").show();
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.onlySaveFile("", function (index, obj) {
                    let loadIndex = window.layer.load();

                    let uploadingFiles = [];
                    let md5sParam = [];
                    if (openPage.tempResultsNew) {
                        openPage.tempResultsNew.map(item => {
                            md5sParam.push(item.storageFile.md5);
                            let uploadingFile = {
                                _id: item.storageFile._id,
                                name: item.storageFile.name,
                                md5: item.storageFile.md5,
                                url: {
                                    url:item.url
                                }
                            };
                            uploadingFiles.push(uploadingFile);
                        });
                    }

                    getStorageDirectory(that.state.currentId, (data)=>{
                        if(data.labels){
                            fileToDirectoryAndAddLabel(md5sParam.join(), that.state.currentId, data.labels, ()=>{
                                window.layer.close(loadIndex);
                                that.setState(prevState=>{
                                    uploadingFiles.map(uploadingFile=>{
                                        prevState.fileDatasource.push(uploadingFile);
                                    });
                                    return prevState;
                                });
                            });
                        }else{
                            filesToDirectory(md5sParam.join(), that.state.currentId, ()=>{
                                window.layer.close(loadIndex);
                                that.setState(prevState=>{
                                    uploadingFiles.map(uploadingFile=>{
                                        prevState.fileDatasource.push(uploadingFile);
                                    });
                                    return prevState;
                                });
                            });
                        }
                    });
                    window.layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    }

    showUploadDialog = ()=> {
        let that = this;
        let x = "930px";
        let y = "640px";
        if (applicationName() == "pms") {
            x = "750px";
            y = "680px";
        }
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&resourceType=5',
            area: [x, y],
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.saveTempFile(function (index, obj) {
                    layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    };

    renderResource(){
        return this.state.fileDatasource.map(item =>{

            let type = item.name.replace(/.*\.([a-zA-Z1-9]*$)/, "$1");
            if(AUDIO_TYPE.indexOf(type) !== -1){
                return <Audio ref={item._id}
                              baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                              baseHeight={window.$(window).height() - HEADER_HEIGHT}
                              offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                              offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                              checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                              unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                              click={(id)=>this.updateCheckedId(id)}
                              {...item} key={item._id}
                              showType={this.state.showType} />
            }
            return <Other ref={item._id}
                          baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                          baseHeight={window.$(window).height() - HEADER_HEIGHT}
                          offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                          offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                          checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                          unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                          click={(id)=>this.updateCheckedId(id)}
                          {...item} key={item._id}
                          showType={this.state.showType} />
        })
    }
}
export class StorageOtherList extends StorageList{

    openSearchDialogBtnName = "打开文件多功能搜索引擎";

    showOnlyFileUploadDialog(){
        let x = "750px";
        let y = "495px";
        let that = this;
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun&onlyUploadFile=true',
            area: [x, y],
            resize: false,
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            success: function(layero, index){
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#myAlert").show();
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.onlySaveFile("", function (index, obj) {
                    let loadIndex = window.layer.load();

                    let uploadingFiles = [];
                    let md5sParam = [];
                    if (openPage.tempResultsNew) {
                        openPage.tempResultsNew.map(item => {
                            md5sParam.push(item.storageFile.md5);
                            let uploadingFile = {
                                _id: item.storageFile._id,
                                name: item.storageFile.name,
                                md5: item.storageFile.md5,
                                url: {
                                    url:item.url
                                }
                            };
                            uploadingFiles.push(uploadingFile);
                        });
                    }

                    getStorageDirectory(that.state.currentId, (data)=>{
                        if(data.labels){
                            fileToDirectoryAndAddLabel(md5sParam.join(), that.state.currentId, data.labels, ()=>{
                                window.layer.close(loadIndex);
                                that.setState(prevState=>{
                                    uploadingFiles.map(uploadingFile=>{
                                        prevState.fileDatasource.push(uploadingFile);
                                    });
                                    return prevState;
                                });
                            });
                        }else{
                            filesToDirectory(md5sParam.join(), that.state.currentId, ()=>{
                                window.layer.close(loadIndex);
                                that.setState(prevState=>{
                                    uploadingFiles.map(uploadingFile=>{
                                        prevState.fileDatasource.push(uploadingFile);
                                    });
                                    return prevState;
                                });
                            });
                        }
                    });
                    window.layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    }

    showUploadDialog = ()=> {
        let that = this;
        let x = "930px";
        let y = "640px";
        if (applicationName() == "pms") {
            x = "750px";
            y = "680px";
        }
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun',
            area: [x, y],
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.saveTempFile(function (index, obj) {
                    layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    };

    openSearchDialog(){
        window.layer.open({
            title: '文件多功能搜索引擎',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/file/fileList.html',
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px',parseInt(window.document.body.clientHeight * 0.9) + 'px'],
            resize: false,
        });
    }

    renderResource(){
        //让图片预览获取；
        picFiles=this.state.fileDatasource;
        return this.state.fileDatasource.map(item =>{
            return <Other ref={item._id}
                          baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                          baseHeight={window.$(window).height() - HEADER_HEIGHT}
                          offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                          offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                          checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                          unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                          click={(id)=>this.updateCheckedId(id)}
                          {...item} key={item._id}
                          showType={this.state.showType} />
        })
    }
}
export class StorageRecycleList extends StorageList{

    constructor(props){
        super(props);
        this.state = {
            directoryDatasource: this.props.directoryDatasource,
            fileDatasource: this.props.fileDatasource,
            currentId: this.props.currentId,
            checkedId: {
                directoryIds: "",
                fileIds: "",
                allIds: "",
                storageDirectoryVisible: false,
                storageDirectoryLoading: false,
                moreBtn:false,
                radioValue:0
            },
        };
    }

    renderBackLists = ()=>{
        defaultHierarchy=0
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            directoryDatasource: nextProps.directoryDatasource,
            fileDatasource: nextProps.fileDatasource,
            currentId: nextProps.currentId,
            storageDirectoryVisible: false,
            storageDirectoryLoading: false,
            moreBtn:false,
            radioValue:0
        })
    }

    showUploadDialog = ()=> {};

    move = ()=>{
        let that = this;
        if(this.state.checkedId.allIds) {
            that.setState({
                storageDirectoryVisible: true
            })
        }else {
            message.error("请至少选择一个文件或文件夹!");
        }
    };

    handleOk(id){
        let that = this;
        let directoryIds = that.state.checkedId.directoryIds.replace(/(.*),$/, '$1');
        let fileIds = that.state.checkedId.fileIds.replace(/(.*),$/, '$1');
        let md5s = [];
        fileIds.split(",").map(item=>{
            if(item){
                md5s.push(that.refs[item].props.md5);
            }
        });
        recover(directoryIds, fileIds, id, md5s.join(","),()=>{
            getStorageDirectoryList(that.state.currentId, (dataSource)=>{
                that.setState({
                    directoryDatasource: dataSource.directorys,
                    fileDatasource: dataSource.files,
                    checkedId: {
                        directoryIds: "",
                        fileIds: "",
                        allIds: ""
                    },
                    storageDirectoryVisible: false,
                    storageDirectoryLoading: false
                })
            });
        });
    };

    handleCancel(){
        this.setState({
            storageDirectoryVisible: false,
            storageDirectoryLoading: false
        })
    };


    renderPosition(){
        return <Position
            showAllFileName={true}
            topParent={{name:'回收站',_id:this.props.match.params.currentId}}
            onClick={(id)=>{
                this.handleDoubleClick(id)}}
            callBackList={(list)=>{
                this.setState({backLists:list})
            }}
            currentId={this.state.currentId}/>;
    }

    delete(){
        let that = this;
        if(this.state.checkedId.allIds) {
            confirm({
                title: '确定要将所选项彻底删除?',
                onOk() {
                    let directoryIds = that.state.checkedId.directoryIds.replace(/(.*),$/, '$1');
                    let fileIds = that.state.checkedId.fileIds.replace(/(.*),$/, '$1');
                    deleteByDirectoryIdsAndFileIds(directoryIds, fileIds, ()=>{
                        getStorageDirectoryList(that.state.currentId, (dataSource)=>{
                            that.setState({
                                directoryDatasource: dataSource.directorys,
                                fileDatasource: dataSource.files,
                                checkedId: {
                                    directoryIds: "",
                                    fileIds: "",
                                    allIds: ""
                                },
                            })
                        });
                    });
                },
                onCancel() {
                    that.setState({confirmVisible:false});
                },
            });
        }else {
            message.error("请至少选择一个文件或文件夹!");
        }
    }

    renderBtn(){
        return (
            <div>
                <Button style={{...leftStyle}} onClick={()=>this.move()}>移动至</Button>
                <Button style={{...leftStyle}} onClick={()=>this.delete()}>彻底删除</Button>
                <Radio.Group style={{marginTop:5}}  onChange={(e)=>{
                    let targetValue=e.target.value
                    if(targetValue===0){
                        btnCtrlKey = "up"
                        ctrlKey = "up"
                        this.state.moreBtn = false
                    }
                    //多选
                    if(targetValue===1){
                        btnCtrlKey = "down"
                        ctrlKey = "down"
                        this.state.moreBtn = true
                        message.warning('按下ctrl不放，也能实现多选文件')
                    }else{
                        btnCtrlKey = "up"
                        ctrlKey = "up"
                        this.state.moreBtn = false
                    }
                    //全选
                    if(targetValue===2){
                        this.getAllChoose()
                    }
                    //反选
                    if(targetValue===3){
                        this.getReverseSelection()
                    }
                    this.state.radioValue=targetValue
                    this.setState({})
                }} value={this.state.radioValue}>
                    <Radio value={0}>单选</Radio>
                    <Radio value={1}>多选</Radio>
                    <Radio value={2}>全选</Radio>
                    <Radio value={3}>反选</Radio>
                </Radio.Group>
                <Search
                    placeholder="请输入文件名"
                    onSearch={searchStr => this.gotoSearch(searchStr)}
                    style={{...rightStyle, width: 200 }}
                />
                <StorageDirectory
                    visible={this.state.storageDirectoryVisible}
                    handleOk={(id)=>this.handleOk(id)}
                    confirmLoading={this.state.storageDirectoryLoading}
                    handleCancel ={()=>this.handleCancel()}
                />
            </div>);
    }

    renderResource(){
        //让图片预览获取；
        picFiles=this.state.fileDatasource;
        return this.state.fileDatasource.map(item =>{
            let type = item.name.replace(/.*\.([a-zA-Z1-9]*$)/, "$1");
            if(PIC_TYPE.indexOf(type) !== -1){
                return <Picture ref={item._id}
                                baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                                baseHeight={window.$(window).height() - HEADER_HEIGHT}
                                offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                                offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                                checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                                unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                                click={(id)=>this.updateCheckedId(id)}
                                {...item} key={item._id}
                                showType={this.state.showType} />
            }else if(VIDEO_TYPE.indexOf(type) !== -1){
                return <Video ref={item._id}
                              baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                              baseHeight={window.$(window).height() - HEADER_HEIGHT}
                              offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                              offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                              checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                              unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                              click={(id)=>this.updateCheckedId(id)}
                              {...item} key={item._id}
                              showType={this.state.showType} />
            }else if(AUDIO_TYPE.indexOf(type) !== -1){
                return <Audio ref={item._id}
                              baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                              baseHeight={window.$(window).height() - HEADER_HEIGHT}
                              offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                              offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                              checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                              unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                              click={(id)=>this.updateCheckedId(id)}
                              {...item} key={item._id}
                              showType={this.state.showType} />
            }else{
                return <Other ref={item._id}
                              baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                              baseHeight={window.$(window).height() - HEADER_HEIGHT}
                              offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                              offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                              checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                              unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                              click={(id)=>this.updateCheckedId(id)}
                              {...item} key={item._id}
                              showType={this.state.showType} />
            }
        })
    }

}
export class StorageContributeList extends StorageList{//专为contribute写的

    constructor(props){
        super(props);
        this.state = {
            directoryDatasource: this.props.directoryDatasource,
            fileDatasource: this.props.fileDatasource,
            currentId: this.props.currentId,
            checkedId: {
                directoryIds: "",
                fileIds: "",
                allIds: ""
            },
            storageDirectoryVisible: false,
            storageDirectoryLoading: false,
            showApplyList: false
        };
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            directoryDatasource: nextProps.directoryDatasource,
            fileDatasource: nextProps.fileDatasource,
            currentId: nextProps.currentId,
            storageDirectoryVisible: false,
            storageDirectoryLoading: false,
            showApplyList: false
        })
    }

    showUploadDialog = ()=>{
        let that = this;
        let x = "930px";
        let y = "640px";
        if (applicationName() == "pms") {
            x = "750px";
            y = "680px";
        }
        window.layer.open({
            title: '上传文件',
            type: 2,
            shade: 0.8,
            content: '/cm-sites/' + applicationName() + '/library/upload/uploadfile.html?fileBtnName=选择文件&uploadFileAfterFun=FileConvertParams&deleteFileAfterFun=delteTempFile&setFileNumFun=setFileNumFun',
            area: [x, y],
            btn: ['选择文件', '一键上传', '保存', '关闭'],
            cancel: function (index, layero) {
                window.layer.close(index);
            },
            end: function (index, layero) {
            },
            yes: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.$("#batchWebUpload").click();
            },
            btn2: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.startAll();
                return false;
            },
            btn3: function (index, layero) {
                let openPage = window[layero.find('iframe')[0]['name']];
                openPage.saveTempFile(function (index, obj) {
                    window.layer.close(index);
                    if (obj) {
                        window.layer.msg(obj.msg, {
                            icon: (obj.icon ? obj.icon : 1),
                            time: (obj.time ? obj.time : 1500)
                        });
                    }
                }, index);
                return false;
            },
            btn4: function (index, layero) {
            }
        });
    };
    renderBackLists = ()=>{
        defaultHierarchy=1
    };

    applyListData = [];

    addToApplyList = () => {
        let that = this;
        let fileIds = that.state.checkedId.fileIds.replace(/(.*),$/, '$1');

        if(fileIds) {
            let allIds = this.state.checkedId.allIds.split(",");
            allIds.map(item => {
                if(item){
                    that.refs[item].unChecked();
                }
            });
            this.setState({
                checkedId:{
                    directoryIds: "",
                    fileIds: "",
                    allIds: ""
                }
            });
            let fileIdArr = fileIds.split(",");
            let fileMd5Arr = [];
            fileIdArr.map(item => {
                if(item){
                    let isPush = true;
                    that.applyListData.map(applyItem => {
                        if(applyItem.md5 === that.refs[item].props.md5){
                            message.error(applyItem.sourceName + "已添加，无须再次添加!");
                            isPush = false;
                        }
                    });
                    if(isPush){
                        fileMd5Arr.push(that.refs[item].props.md5);
                    }
                }
            });
            if(fileMd5Arr.length === 0){
                this.showApplyList();
            }else{
                getByMd5s(fileMd5Arr.join(","), (data)=>{
                    this.applyListData.push(...data);
                    this.showApplyList();
                });
            }
        }else{
            if(this.applyListData.length === 0){
                message.error("请至少选择一个文件!");
            }else{
                this.showApplyList();
            }
        }
    };

    showApplyList(){
        notification.success({
            message: <Button onClick={()=>this.openApplyDownload()}>提交</Button>,
            description: <ApplyList dataSource={this.applyListData} remove={(sourceId, newDatasource)=>this.removeToApplyList(sourceId, newDatasource)}/>,
            placement: "bottomRight",
            duration: null,
            key:"applyList",
            onClose: ()=>{
                this.applyListData = [];
            }
        });
    };

    openApplyDownload(){
        let arrs = this.applyListData;
        let that = this;
        window.layer.open({
            title: '资源下载审核',
            type: 2,
            content: '/cm-sites/' + applicationName() + '/downloadApplication/downloadApplication.html?actButtonId=8',
            area: [parseInt(window.$(window).width() * 0.72) + 'px',parseInt(window.$(window).height() * 0.8) + 'px'],
            success: function (layero, index) {
                let iframeWin = window[layero.find('iframe')[0]['name']];
                iframeWin.imgArray = arrs;
            },
            end: function () {
                that.applyListData = [];
                notification.close("applyList");
            }
        });
    };

    removeToApplyList = (sourceId, newDatasource) => {
        if(newDatasource && newDatasource.length === 0){
            notification.close("applyList");
        }
        this.applyListData = newDatasource;
    };

    renderBtn(){
        return (
            <div>
                <div style={{...leftStyle}}>
                    {/*<Upload {...props} fileList={this.state.fileList}>*/}
                    <Button type={"primary"} onClick={()=>this.showUploadDialog()} icon={"cloud-upload"}>资源上传申请</Button>
                    {/*</Upload>*/}
                </div>
                <Button style={{...leftStyle}} onClick={()=>this.addToApplyList()}>加入资源下载申请列表</Button>
                <Search
                    placeholder="请输入文件名"
                    onSearch={searchStr => this.gotoSearch(searchStr)}
                    style={{...rightStyle, width: 200 }}
                />
            </div>);
    }

    calcContentArea(){
        let allWidth = window.$(window).width() - (!this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - 10*2 - MARGIN*2;
        let blockWidth = 156;
        let blockHeight = 130;
        let count = this.state.directoryDatasource.length + this.state.fileDatasource.length;

        let colsMaxCount = Math.floor(allWidth / blockWidth);//最大列数
        let rowsCount = Math.ceil(count / colsMaxCount);//行数

        let allHeight = rowsCount * blockHeight;
        return [allWidth, allHeight];
    }


    renderPosition(){
        return <Position
            showAllFileName={true}
            onClick={(id)=>{
                this.handleDoubleClick(id)}}
            callBackList={(list)=>{
                this.setState({backLists:list})
            }}
            currentId={this.state.currentId}/>;
    }

    renderResource(){
        //让图片预览获取；
        picFiles=this.state.fileDatasource;
        return this.state.fileDatasource.map(item =>{
            let type = item.name.replace(/.*\.([a-zA-Z1-9]*$)/, "$1");
            if(PIC_TYPE.indexOf(type) !== -1){
                return <Picture ref={item._id}
                                baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                                baseHeight={window.$(window).height() - HEADER_HEIGHT}
                                offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                                offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                                checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                                unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                                click={(id)=>this.updateCheckedId(id)}
                                {...item} key={item._id}
                                showType={this.state.showType} />
            }else if(VIDEO_TYPE.indexOf(type) !== -1){
                return <Video ref={item._id}
                              baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                              baseHeight={window.$(window).height() - HEADER_HEIGHT}
                              offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                              offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                              checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                              unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                              click={(id)=>this.updateCheckedId(id)}
                              {...item} key={item._id}
                              showType={this.state.showType} />
            }else if(AUDIO_TYPE.indexOf(type) !== -1){
                return <Audio ref={item._id}
                              baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                              baseHeight={window.$(window).height() - HEADER_HEIGHT}
                              offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                              offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                              checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                              unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                              click={(id)=>this.updateCheckedId(id)}
                              {...item} key={item._id}
                              showType={this.state.showType} />
            }else{
                return <Other ref={item._id}
                              baseWidth={window.$(window).width()-(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) - NAVIGATE_LEVEN2_MARGIN - NAVIGATE_LEVEN2_WIDTH}
                              baseHeight={window.$(window).height() - HEADER_HEIGHT}
                              offsetX={parseInt(this.props.navigateStatus?NAVIGATE_OPEN:NAVIGATE_CLOSE) + parseInt(NAVIGATE_LEVEN2_MARGIN) + parseInt(NAVIGATE_LEVEN2_WIDTH) + MARGIN}
                              offsetY={parseInt(HEADER_HEIGHT) + MARGIN}
                              checkedFun={(id)=>this.updateCheckedId(id, "file", "add")}
                              unCheckedFun={(id)=>this.updateCheckedId(id, "file", "remove")}
                              click={(id)=>this.updateCheckedId(id)}
                              {...item} key={item._id}
                              showType={this.state.showType} />
            }
        })
    }

}

class Position extends React.Component{

    state = {
        dataSource: []
    };

    constructor(props){
        super(props);
        this.updatePosition(props.currentId);
    }


    componentWillReceiveProps(nextProps, nextContext) {
        if(this.props.currentId !== nextProps.currentId){
            this.updatePosition(nextProps.currentId);
        }
    }

    updatePosition(id){
        let index = window.layer.load();
        let that = this;
        getAllParent(id, (data)=>{
            window.layer.close(index);
            if(!data){
                data = [];
            }
            this.props.callBackList&&this.props.callBackList(data)
            if(this.props.topParent){
                data.push(this.props.topParent);
            }
            that.setState({
                dataSource: data.reverse()
            })
        })
    }

    handleClick(path){
        if(typeof this.props.onClick === "function"){
            this.props.onClick(path);
        }
    }

    render() {
        return (<span>
            {
                this.state.dataSource.map((item, index) => {
                    let showName = item.name;
                    if(showName.length > 10){
                        showName = showName.replace(/^(.{3}).*(.{3})$/,"$1...$2");
                    }
                    if(index == 0){
                        if(showName === "全部文件" && !this.props.showAllFileName)
                            return <span key={index}
                                         title={item.name}
                            >{showName}</span>;
                        return (<span
                            onClick={(e)=>this.handleClick(item._id)}
                            title={item.name}
                            key={index} style={{cursor: "pointer", color: "#0050B3"}}>{showName}</span>);
                    }else{
                        return (<span key={index}>/<span
                            title={item.name}
                            onClick={(e)=>this.handleClick(item._id)}
                            style={{cursor: "pointer", color: "#0050B3"}}>{showName}</span></span>);
                    }
                })
            }
           {/* {this.state.dataSource.length>2? <span >/<span>
                <Icon type="enter" style={{cursor: "pointer",color:'#0050B3'}} onClick={()=>{
                    let id=this.state.dataSource[this.state.dataSource.length-2]._id
                    this.handleClick(id)
                }} />
               </span></span>:null
            }*/}
        </span>);
    }
}

class File extends React.Component{
    state = {
        checked: this.props.checked,
        rename: false,
        name: this.props.name,
        showType: this.props.showType,
        createTime:this.props.createTime?this.props.createTime:(this.props.originalCreateTime?this.props.originalCreateTime:null)
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            showType: nextProps.showType,
        })
    }

    handleClick(e){
        this.setState(prevState => {
            if((typeof this.props.checkedFun === "function" ) && !prevState.checked){
                this.props.checkedFun(this.props._id);
            }

            if((typeof this.props.unCheckedFun === "function" ) && prevState.checked){
                let checkedAllIds = this.props.unCheckedFun(this.props._id);
                if(ctrlKey === "up" && checkedAllIds &&
                    !(checkedAllIds === this.props._id || checkedAllIds === this.props._id + ",")
                ){
                    this.props.checkedFun(this.props._id);
                    window.onkeydown = listenKeyDown;
                    return {
                        checked: !(checkedAllIds === this.props._id || checkedAllIds === this.props._id + ","),
                        rename: false
                    };
                }else{
                    window.onkeydown = listenKeyDown;
                    return {
                        checked: !prevState.checked,
                        rename: false
                    };
                }
            }

            return {
                checked: !prevState.checked,
            }
        });
    }

    handleRenameBlur(ajaxRenameFun, ajaxPrimaryKey, callBackFun){
        let newName = this.refs.nameInput.state.value;
        if(newName && this.state.name !== newName){//如果修改了名称
            ajaxRenameFun(ajaxPrimaryKey, newName, (res)=>{
                if(res){//如果修改成功
                    this.setState({
                        checked: false,
                        rename: false,
                        name: newName
                    })
                }else{
                    this.setState({
                        checked: false,
                        rename: false
                    })
                }
                if( typeof callBackFun == "function"){
                    callBackFun(newName);
                }
                window.onkeydown = listenKeyDown;
            });
        }else{
            this.setState({
                checked: false,
                rename: false
            });
            if( typeof callBackFun == "function"){
                callBackFun();
            }
        }
        if((typeof this.props.unCheckedFun === "function" )) {
            this.props.unCheckedFun(this.props._id);
        }
        window.onkeydown = listenKeyDown;
    }

    unChecked(){
        this.setState({
            checked: false,
            rename: false
        });
    }
    ToChecked(){
        this.setState({
            checked: true,
            rename: false
        });
    }

}
File.defaultProps = {
    checked: false,
    showType: "small"
};

class Directory extends File{

    rename(callBackFun){
        let that = this;
        window.onkeydown = (e)=>{
            let ev = e || window.event;
            if(ev.keyCode === 13){
                that.handleRenameBlur(storageDirectoryRename, that.props._id, callBackFun);
                window.onkeydown = listenKeyDown;
            }
        };
        this.setState({
            rename: true
        });
        this.refs.nameInput.focus();
    }

    handleDoubleClick(e){
        if(typeof this.props.onDoubleClick === "function")
            this.props.onDoubleClick(e);
    }

    render() {
            return <div
                className={("directory-"+this.state.showType+"-display ") + "unselect " + (this.state.checked ? "directory-checked" : "") }
                onClick={(e) => this.handleClick(e)}
                onDoubleClick={(e) => this.handleDoubleClick(e)}
            >
                <img src={"images/folder.png"} className={"file-img-"+this.state.showType} />
                <div title={this.state.name} style={{width: this.state.showType==="list"?"30%":"80%", margin: "auto"}} className={"file-name-"+this.state.showType+" " + (this.state.showType==="list" ? "list-item ":"")}>
                    <Input style={{display: this.state.rename ? "block" : "none"}} ref={"nameInput"}
                           defaultValue={this.state.name}
                           maxLength={50}
                           onClick={(e) => e.stopPropagation()}
                           onBlur={() => this.handleRenameBlur(storageDirectoryRename, this.props._id)}/>
                    {this.state.rename ? "" : omitName(this.state.name, this.state.name)}
                </div>
                <div className={"file-createTime " + (this.state.showType==="list" ? "list-item ":"")}>
                    创建时间：{this.state.createTime?window.formatDate(this.state.createTime):""}
                </div>
                <div className={"file-type " + (this.state.showType==="list" ? "list-item ":"")}>
                    文件夹
                </div>
            </div>
    }
}
class Resource extends File{

    rename(callBackFun){
        let that = this;
        window.onkeydown = (e)=>{
            let ev = e || window.event;
            if(ev.keyCode === 13){
                that.handleRenameBlur(storageFileRename, that.props.md5, callBackFun);
                window.onkeydown = listenKeyDown;
            }
        };
        this.setState({
            rename: true
        });
    }

    render() {
        return <div className={("directory-"+this.state.showType+"-display ") + "unselect " + (this.state.checked?"directory-checked":" ")}
                    onClick={(e)=>this.handleClick(e)}
                    onDoubleClick={(e)=>this.handleDoubleClick()}>
            {this.renderShowPic()}
            <div style={{width: this.state.showType==="list"?"30%":"80%", margin: "auto"}} className={"file-name-"+this.state.showType+" " + (this.state.showType==="list" ? "list-item ":"")} title={this.state.name}>
                <Input style={{display:this.state.rename?"block":"none"}} ref={"nameInput"} defaultValue={this.state.name}
                    maxLength={50}
                    onClick={(e)=>e.stopPropagation()}
                    onBlur={()=>this.handleRenameBlur(storageFileRename, this.props.md5)}/>
                {this.state.rename?"":omitName(this.state.name, this.state.name)}
            </div>
            <div className={"file-createTime " + (this.state.showType==="list" ? "list-item ":"")}>
                创建时间：{this.state.createTime?window.formatDate(this.state.createTime):""}
            </div>
            <div className={"file-type " + (this.state.showType==="list" ? "list-item ":"")}>
                {this.renderFileType()}
            </div>
        </div>
    }
}
class Video extends Resource{

    handleDoubleClick = ()=>{
        let that = this;
        window.layui.config({
            base: '/cm-sites/layuiadmin/' //静态资源所在路径
        }).extend({
            index: 'lib/index' //主入口模块
        }).use(["index","buttons"], function () {
            let buttons = window.layui.buttons;
            window.loading.show();
            getByPath(that.props.url.url||that.props.path, (video)=>{
                window.loading.hide();
                if(video){
                    buttons.view(video, 3, "视频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                }else{
                    message.error("该资源不在媒资库中，无法查看。");
                }
            });
        })
    };

    renderShowPic(){
		let width = FILE_PROPERTY.height[this.state.showType];
		let picWidth = FILE_PROPERTY.showPic[this.state.showType];
		let border = 1;
		let playWidth = 26;

		let left = (width - 2 * border - playWidth) / 2;
		let top = (picWidth - playWidth) / 2;
		if(this.state.showType==="list"){
			left = top;
		}
        return <div style={this.state.showType==="list"?{position:"relative",display:"inline-block", width:"40px", height:"40px"}:{position:"relative", width:"100%", height:picWidth+"px"}}>
            <img src={this.props.url.thumbnailsURL||this.props.path+'/thumbnails/1'} width={picWidth} height={picWidth} style={{objectFit:"cover"}} />
            <img src={"images/play.png"} width={26} height={26}
				style={{position:"absolute", top, left, opacity: "0.8"}} />
        </div>;
    }

    renderFileType(){
        return "视频"
    }
}
class Picture extends Resource{

    handleDoubleClick = ()=>{
        let that = this;
        window.layui.config({
            base: '/cm-sites/layuiadmin/' //静态资源所在路径
        }).extend({
            index: 'lib/index' //主入口模块
        }).use(["index","buttons"], function () {
            let buttons = window.layui.buttons;
            window.loading.show();
            getByPath(that.props.url.url, (pic)=>{
                window.loading.hide();

                //图片滚动预览
                let pictureList = picFiles;
                let index=0;

                let picPaths=[];
                //获取当前图片在数组中的索引；
                for(let i=0;i<pictureList.length;i++){
                    picPaths.push(pictureList[i].path);
                }

                //更具paths获取pictureinfos
                let params={paths:picPaths};
                getPictureInfosByPath(params,function(pics){
                    for(let i=0;i<pics.length;i++){
                        if(pics[i].path==pic.path){
                            index=i;
                            break;
                        }
                    }
                    let  viewPic={
                        list:pics,
                        index:index
                    };
                    buttons.view(viewPic, 2, "图片详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                })
            });
        })
    };

    renderShowPic(){
        return <img src={this.props.url.smallUrl||this.props.path} width={FILE_PROPERTY.showPic[this.state.showType]} height={FILE_PROPERTY.showPic[this.state.showType]} style={{objectFit:"cover"}} />;
    }

    renderFileType(){
        return "图片"
    }

}
class Audio extends Resource{

    handleDoubleClick = ()=>{
        let that = this;
        window.layui.config({
            base: '/cm-sites/layuiadmin/' //静态资源所在路径
        }).extend({
            index: 'lib/index' //主入口模块
        }).use(["index","buttons"], function () {
            let buttons = window.layui.buttons;
            window.loading.show();
            getByPath(that.props.url.url||that.props.path, (audio)=>{
                window.loading.hide();
                if(audio){
                    buttons.view(audio, 5, "音频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                }
                else{
                    message.error("该资源不在媒资库中，无法查看。");
                }
            });
        })
    };

    renderShowPic(){
        return <img src={"/cm-sites/pms/library/images/audio.png"} width={FILE_PROPERTY.showPic[this.state.showType]} height={FILE_PROPERTY.showPic[this.state.showType]} style={{objectFit:"cover"}} />
    }

    renderFileType(){
        return "音频"
    }
}
class Other extends Resource{

    handleDoubleClick = ()=>{
        let that = this;
        window.layui.config({
            base: '/cm-sites/layuiadmin/' //静态资源所在路径
        }).extend({
            index: 'lib/index' //主入口模块
        }).use(["index","buttons"], function () {
            let buttons = window.layui.buttons;
            window.loading.show();
            getByPath(that.props.url.url||that.props.path, (file)=>{
                window.loading.hide();
                if(file){
                    if(that.props.type === STORAGE_TYPE_PIC){
                        buttons.view(file, 2, "图片详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                    }else if(that.props.type === STORAGE_TYPE_VIEDO){
                        buttons.view(file, 3, "视频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                    }else if(that.props.type === STORAGE_TYPE_AUDIO){
                        buttons.view(file, 5, "音频详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                    }else{
                        buttons.view(file, 4, "文件详情", that.props.baseWidth, that.props.baseHeight, that.props.offsetX, that.props.offsetY);
                    }
                }else{
                    message.error("该资源不在媒资库中，无法查看。");
                }
            });
        })
    };

    renderShowPic(){
        return <img src={"images/other.png"} width={FILE_PROPERTY.showPic[this.state.showType]} height={FILE_PROPERTY.showPic[this.state.showType]} style={{objectFit:"cover"}} />
    }

    renderFileType(){
        return "其他"
    }
}

export class StorageDirectory extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            directoryDatasource: [],
            currentId: "",
            checkedId: {
                directoryIds: "",
            },
            visible: this.props.visible,
            confirmLoading: this.props.confirmLoading
        };
        let that = this;
        createStorageDirectory("全部文件", "", (allDirectory)=>{
              getStorageDirectoryList(allDirectory._id, (data)=>{
                that.setState({
                     currentId: allDirectory._id,
                     directoryDatasource: data.directorys
                  })
              });
         });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            visible: nextProps.visible,
            confirmLoading: nextProps.confirmLoading
        });
    };

    handleOk = ()=>{
        if(this.state.checkedId.directoryIds) {
            //永远只是改第一个
            let id = this.state.checkedId.directoryIds.replace(/^([^,]+),.*/, "$1");
            this.setState({
                confirmLoading: true
            });
            this.props.handleOk(id);
        }else{
            message.error("请选择要移动至的一个目录");
        }
    };

    handleCancel = ()=>{
        this.props.handleCancel();
        this.setState({
            visible: false
        });
    };

    //选中的文件夹与文件id
    updateCheckedId(id, type, op){
        if(op === "add"){
            this.setState(prevState => {
                //弄成只能选中一个文件
                if(prevState.checkedId.directoryIds){//这里是为了阻止多选，所以加了一个方法。
                    let ids = prevState.checkedId.directoryIds.split(",");
                    ids.map(_id => {
                        if(this.refs[_id] && this.refs[_id].unChecked && _id!==id){
                            this.refs[_id].unChecked();
                        }
                        return _id;
                    });
                }
                if(type === "directory"){
                    prevState.checkedId.directoryIds = id + ",";
                }
                return prevState;
            });

            // this.setState(prevState => {
            //     if(type === "directory"){
            //         prevState.checkedId.directoryIds += id + ",";
            //     }
            //     return prevState;
            // })
        }else{
            this.setState(prevState => {
                if(type === "directory"){
                    prevState.checkedId.directoryIds = prevState.checkedId.directoryIds.replace(id + ",", "");
                }
                return prevState;
            })
        }
    }

    handleDoubleClick(storageDirectoryId){
        getStorageDirectoryList(storageDirectoryId, (data)=>{
            this.setState({
                directoryDatasource: data.directorys,
                currentId: storageDirectoryId,
                checkedId: {
                    directoryIds: "",
                },
            })
        });
    }

    calcContentArea(){
        let allWidth = 800;
        let blockWidth = 156;
        let blockHeight = 130;
        let count = this.state.directoryDatasource.length;

        let colsMaxCount = Math.floor(allWidth / blockWidth);//最大列数
        let rowsCount = Math.ceil(count / colsMaxCount);//行数

        let allHeight = rowsCount * blockHeight;
        return [allWidth, allHeight];
    }

    render() {
        let area = this.calcContentArea();
        return (
            <Modal
                title="所有文件夹"
                width={800}
                visible={this.state.visible}
                onOk={()=>this.handleOk()}
                confirmLoading={this.state.confirmLoading}
                onCancel={()=>this.handleCancel()}
                bodyStyle={{
                    height:"400px"
                }}
            >
                <div>
                    <div style={{lineHeight: "50px" , height:"50px"}}>
                 {/*   <span>返回上一级|</span>*/}
                        当前位置：
                        <Position
                            showAllFileName={true}
                            onClick={(id)=>this.handleDoubleClick(id)}
                            currentId={this.state.currentId}/>
                    </div>
                </div>
                <div style={{clear:"both", height:"297px", overflow:"auto"}}>
                    <div style={{height:area[1] + "px"}}>
                        {this.state.directoryDatasource.map(item =>{
                            return <Directory ref={item._id}
                                              checkedFun={(id)=>this.updateCheckedId(id, "directory", "add")}
                                              unCheckedFun={(id)=>this.updateCheckedId(id, "directory", "remove")}
                                              onDoubleClick={(e)=>this.handleDoubleClick(item._id)} {...item} key={item._id} />
                        })}
                    </div>
                </div>
            </Modal>
        );
    }
}

class ApplyList extends React.Component{//申请列表

    constructor(props){
        super(props);
        this.state = props;
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState(nextProps);
    }

    remove(sourceId){
        this.setState(prevState => {
            let newDatasource = [];
            prevState.dataSource.map(item => {
                if(item.sourceId !== sourceId){
                    newDatasource.push(item);
                }
            });
            this.props.remove(sourceId, newDatasource);
            return {
                ...prevState,
                dataSource: newDatasource
            };
        });
    };

    render() {
        return <div style={{width: "100%"}}>
            <table width={"100%"}>
                <tbody>
                {
                    this.state.dataSource.map(item => {
                        return (<tr key={"id_"+item.sourceId}>
                            <td>{item.sourceName}</td>
                            <td align={"right"}><Icon type="close-circle" onClick={()=>this.remove(item.sourceId)} /></td>
                        </tr>);
                    })
                }
                </tbody>
            </table>
        </div>
    }
}




const omitName = (str, oldStr)=>{
    if(isIE()){
        let letter = str.replace(/[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7]/g, "");
        let chinessLen = str.length - letter.length;
        let allLen = chinessLen * 2 + letter.length;
        if(allLen <= 40){
            if(str === oldStr){
                return str;
            }else{
                return str + "...";
            }
        }
        return omitName(str.substring(0, str.length - 1));
    }else{
        return str;
    }
};
